/**
 * Utility module: getTeams/shortnames.js.
 */

export default {
  'Czech Republic': 'Czech Rep.',
  'Korea Republic': 'Korea Rep.',
};
